import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export function apicep(cep) {
  return new Promise((resolve, reject) => {
    axios.get(`externalServices/${cep}`)
      .then(resp => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(err)
      })
  })
}
